import React from "react";
import TutorsShell from "./TutorsShell";
import AdminTutorsView from "./AdminTutorsView";

/**
 * The owner's P&L: booking activity, instructor approvals, payouts and what the
 * school is earning. A separate nav item from My Teaching because the reader is
 * different, not just the role.
 */
export default function BookingsRevenue() {
  return (
    <TutorsShell
      title="Bookings & Revenue"
      subtitle="Booking activity, instructor access and what your school is earning"
    >
      <AdminTutorsView />
    </TutorsShell>
  );
}
